module.exports = __webpack_public_path__ + "static/media/img_2.f5982a9d.png";